





















import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

import DayTradeListing from "@/shared/components/investments/drivewealth/DayTradeListing.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    DayTradeListing,
    DrivewealthNavigation
  }
})
export default class DayTradesPage extends Vue {
  @Prop({required: false}) username: string;
  @Prop({required: false}) partnerId: number;
  @Prop({required: false}) accountId: number;

  drivewealthStore = useDrivewealthStore();
}
